import "./StatusStyle.scss";
import { IJSLComponent, IJSLVNode, refresh } from "jsl-render";
import { DialogComponent, LoadingComponent, SelectComponent } from "jsl-ui";
import { AjaxController } from "../../ajax/AjaxController";
import { mapUrl } from "../../helper/mapUrl";
import { BCSPjmProjektePositionen } from "../../ajax/types/BCSPjmProjektePositionen";
import { RepStatusEnum } from "../../ajax/types/RepStatusEnum";

export class AktuellerStatusComponent implements IJSLComponent {

    private isLoading = false;
    private isAllowedToAcceptKVA = false;
    private isVerschrotten: boolean;

    public constructor(private statusText: string, private projektepositionen: BCSPjmProjektePositionen, private token: string) {
        AjaxController.CheckZKDVorkassaForKVARechnung(this.projektepositionen.USER_KTO, this.token)
            .then((val) => {
                this.isAllowedToAcceptKVA = !val;
                //   console.log(this.isAllowedToAcceptKVA);
                //   this.isAllowedToAcceptKVA = false;
                refresh();
            })
            .catch((error) => {
                console.log(error);
            });
    }

    public render(): IJSLVNode {
        if (this.isLoading) {
            return new LoadingComponent().render();
        }
        let kva_anzeige: string | IJSLVNode = "";
        let rep_status_anzeige: string | IJSLVNode = "";
        let rep_vorkassa_rechnung_anzeige: string | IJSLVNode = "";
        let img_anzeige: string | IJSLVNode = "";
        // this.projektepositionen.USER_RechnungBelid = 10000008;
        // this.projektepositionen.USER_KVABelid = 10000008;
        //console.log(this.projektepositionen.USER_RepStatus);c
        //console.log(this.projektepositionen.USER_RechnungBelid);
        if (this.projektepositionen.USER_RepStatus === 410 /*&& this.projektepositionen.USER_KVABelid*/) {
            //console.log("yes");
            img_anzeige = <a target="_blank"
                href={mapUrl("Ajax/GetKVA?ProPosId=" + this.projektepositionen.ProjektPosID +
                    "&BelegId=" + this.projektepositionen.USER_KVABelid + "&Token=" + this.token)} style="vertical-align: middle;">
                <img class="download-icon" src={mapUrl("Ajax/GetDownloadImage/Download")}></img>
            </a>;
            kva_anzeige = this.isAllowedToAcceptKVA ? <div class="info-box" id="akt-status" style="background:rgb(240,240,240)">
                <div class="sub-heading"><span style="font-weight:bold">Wie möchten Sie fortfahren?</span></div>
                <form name="kva" id="radio-container">
                    <label class="radio">
                        <span class="radio_input">
                            <input type="radio" id="kva_yes" name="kva_decision" value="yes" change={() => refresh()} />
                            <span class="radio_control"></span>
                        </span>
                        <span class="radio_label" for="kva_yes"> Kostenvoranschlag <span style="color: green; font-weight: bold">akzeptieren</span> (Gerät wird laut Kostenvoranschlag repariert und zurückgesendet)</span>
                    </label>
                    <br />
                    <label class="radio">
                        <span class="radio_input">
                            <input type="radio" id="kva_no" name="kva_decision" value="no" change={() => refresh()}></input>
                            <span class="radio_control"> </span>
                        </span>
                        <span class="radio_label" for="kva_no"> Kostenvoranschlag <span style="color: red; font-weight: bold">ablehnen</span> (Möglichkeit der Rücksendung oder Verschrottung)</span>
                    </label>
                </form>
                <p style="text-align:center"><button class="jsl-button" disabled={(document.forms as any).kva?.kva_decision.value ? undefined : "disabled"} click={() => {
                    const form = (document.forms as any).kva;
                    const valueAsString = form.elements.kva_decision.value;
                    if (!valueAsString) {
                        alert("Bitte ja oder nein auswählen");
                        return;
                    }
                    const value = valueAsString === "yes";
                    if (value) {
                        this.isLoading = true;
                        refresh();
                        AjaxController.SetKVABedingung(value, this.projektepositionen.ProjektPosID, RepStatusEnum.Reperatur, this.token, this.projektepositionen.USER_KTO).then((kvaIsSet) => {
                            if (kvaIsSet) {
                                // location.reload();
                                DialogComponent.show({
                                    modal: true,
                                    allowResize: true,
                                    header: "Kostenvoranschlag akzeptiert",
                                    footer: DialogComponent.Ok(),
                                    content: "Sie erhalten in Kürze eine Bestätigung per E-Mail! Vielen Dank!",
                                    maxWidth: "400px"
                                })
                            } else {
                                this.isLoading = false;
                                refresh();
                                alert("Akzeptieren des Kostenvoranschlags hat nicht funktioniert!");
                            }
                        }).catch((error) => {
                            this.isLoading = false;
                            refresh();
                            alert("ERROR: Kostenvoranschlag konnte nicht akzeptiert werden");
                        });
                    } else {
                        this.showAbgeschlossenDialog(value);
                    }
                }}>Auswahl annehmen</button></p>
            </div> : <div><span>Kontaktiere Sie bitte die Hotline!</span>{/*<button class="jsl-button" click={() => {
                this.showAbgeschlossenDialog(false);
            }}>Kostenvoranschlag <span style="color: red; font-weight: bold">ablehnen</span></button>*/}</div>;
        } else if ((this.projektepositionen.USER_RepStatus === 790 || this.projektepositionen.USER_RepStatus === 800) && this.projektepositionen.USER_RechnungBelid) {
            img_anzeige = <a href={mapUrl("Ajax/GetRechnung?ProPosId=" + this.projektepositionen.ProjektPosID + "&BelegId=" + this.projektepositionen.USER_RechnungBelid + "&Token=" + this.token)} target="_blank" style="vertical-align: middle">
                <img class="download-icon" src={mapUrl("Ajax/GetDownloadImage/Download")}></img>
            </a>;
            rep_status_anzeige = <div>
                {img_anzeige}<label style="padding-left: 0.5rem">{
                    this.projektepositionen.USER_RepArt === 30 && !this.projektepositionen.USER_RENummerPREKassa ?
                        "Rechnung herunterladen" :
                        "Reparaturbericht herunterladen"}</label>
            </div>;
        }
        if (this.projektepositionen.USER_RENummerPREKassa) {
            rep_vorkassa_rechnung_anzeige = <div>
                <a href={mapUrl("Ajax/GetRechnung?ProPosId=" + this.projektepositionen.ProjektPosID + "&BelegId=" + this.projektepositionen.USER_RENummerPREKassa + "&Token=" + this.token)} target="_blank" style="vertical-align: middle">
                <img class="download-icon" src={mapUrl("Ajax/GetDownloadImage/Download")}></img>
            </a>
            <label style="padding-left: 0.5rem">Rechnung herunterladen</label>
        </div>;
        }
        return <div class="status-info">
            <span style="text-align: left; font-size: 20px; font-weight: normal;">
                Ihr Gerät befindet sich derzeit im Status:
                <span style="font-weight: bold; padding-left: 0.5rem; padding-right: 0.5rem">
                    {this.statusText}
                </span>
            </span>
            {kva_anzeige}
            {rep_vorkassa_rechnung_anzeige}
            {rep_status_anzeige ? "" : img_anzeige}
            {rep_status_anzeige}
        </div>;
    }

    private showAbgeschlossenDialog(value: boolean) {
        const selectComp = new SelectComponent({
            data: [{ value: 810, text: "Unrepariert retour" },
            { value: 820, text: "Verschrottung" }
            ],
            style: "max-width:80vw;width:20rem",
            enableSearch: false,
            focusFirstItem: true,
        });
        DialogComponent.show({
            modal: true,
            header: "Eine Möglichkeit auswählen",
            minWidth: "20rem",
            maxWidth: "40rem",
            footer: <div>{DialogComponent.Cancel()}{DialogComponent.Ok(() => {
                this.isVerschrotten = selectComp.getValue() === RepStatusEnum.AbgeschlossenVerschrotten;
                if (this.isVerschrotten) {
                    DialogComponent.show({
                        modal: true,
                        header: "Verschrottung",
                        minWidth: "25rem",
                        footer: <div>{DialogComponent.Cancel()}{DialogComponent.Ok(() => {
                            AjaxController.SetKVABedingung(value, this.projektepositionen.ProjektPosID, RepStatusEnum.AbgeschlossenVerschrotten, this.token, this.projektepositionen.USER_KTO).then((kvaIsSet) => {
                                // console.log(kvaIsSet);
                                if (kvaIsSet) {
                                    location.reload();
                                } else {
                                    alert("KVA ablehnen hat nicht funktioniert!");
                                }
                            });
                        })}</div>,
                        content: <div>Möchten Sie mit der <span style="color: red; font-weight: bold">Verschrottung</span> der Maschine wirklich fortfahren?</div>
                    });
                } else {
                    AjaxController.SetKVABedingung(value, this.projektepositionen.ProjektPosID, RepStatusEnum.AbgeschlossenUnerledigtRetour, this.token, this.projektepositionen.USER_KTO).then((kvaIsSet) => {
                        // console.log(kvaIsSet);
                        if (kvaIsSet) {
                            location.reload();
                        } else {
                            alert("KVA ablehnen hat nicht funktioniert!");
                        }
                    });
                }
                return false;
            })}</div>,
            content: <div>{selectComp}</div>
        });
    }
}
